import moment from "moment";
import { DOWNLOAD_ARTIFACT_CONFIG } from "./constants/downloadArtifacts";
import { createdAtToUTC } from "../../utils/date";
import {h} from "preact"
import {Tooltip} from "antd";

var countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

export function getTransactionErrorDescription(transaction) {

    const { service_name, message } = transaction;

    if (service_name === "veridoc") {
        return message?.recognitionResults?.error;
    }
    if (service_name === "veriface") {
        if (message?.Similarity === undefined) {
            return "Internal Server Error";
        }
    }
    if (service_name === "verilive") {
        if (["attack", "unfinished"].includes(message?.status)) {
            return `${message?.status}, ${message?.reason}`;
        }
    }
    return null;
}

export function getTransactionStatus(transaction) {

    const { service_name, message } = transaction;

    if (service_name === "veridoc") {
        if (!!message?.recognitionResults?.error) {
            return "Failed";
        } else {
            return "Passed";
        }
    }
    if (service_name === "veriface") {
        if (message?.status === "match") {
            return "Passed";
        } else {
            return "Failed";
        }
    }
    if (service_name === "verilive") {
        if (message?.status === "real") {
            return "Passed";
        }
        if (message?.status === "attack") {
            return "Failed";
        }
        if (message?.status === "unfinished") {
            return "Unfinished";
        }
    }
}

export function getTransactionStatusType(status) {

    let typeMapping = {
        "Passed": "success",
        "Failed": "danger",
        "Unfinished": "warning"
    };

    return typeMapping[status];
}

export function getTransactionTimeAtUTC(transaction) {
    // return createdAtToUTC(transaction.created_at);
    const date = transaction.created_at;
    return transaction.created_at
}
export const convertToCountryName = (code) => {
    return countries.getName(code, "en");
}
export const getFlagEmoji = (countryCode) => {

    const convertedAlpha = countries.alpha3ToAlpha2(countryCode);

    if (!convertedAlpha) return "";

    const codePoints = countryCode.length === 2 ? countryCode : convertedAlpha
        .toUpperCase()
        .split("")
        .map((char) => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
};

export const getVendorDisplay = (vendorCode, options = {}) => {
  const {
    livenessVersion,
    showName = false,
    iconSize = 16,
    gap = "8px"
  } = options;

  if(!vendorCode){
      return "-";
  }

  const vendorMapping = {
    vg: {
      name: "Verigram",
      icon: "https://verigram.ai/favicon.ico"
    },
    ft: {
      name: "Facetec",
      icon: "https://play-lh.googleusercontent.com/-Hs79n-HveWnlLgpiKWc_vCqRrg3B7gB_0Wupt2UrJckz__hyAZwuBIyInkllRr1w1E=w240-h480"
    }
  };

  const vendorInfo = vendorMapping[vendorCode] || { name: vendorCode, icon: null };
  const title = vendorCode === "vg" && livenessVersion
    ? `${vendorInfo.name} (VeriLive ${livenessVersion})`
    : vendorInfo.name;

  return (
    <Tooltip title={title}>
      <span style={{ display: "flex", gap }}>
        {vendorInfo.icon && (
          <img
            src={vendorInfo.icon}
            alt={vendorInfo.name}
            style={{ width: `${iconSize}px`, height: `${iconSize}px`, objectFit: "contain" }}
          />
        )}
        {showName && vendorInfo.name}
      </span>
    </Tooltip>
  );
};
//By default, all times shown in Almaty/Asia utc +5.
export const convertDateFormat = (date) => {
    return moment(date).utcOffset("+05:00").format('YYYY-MM-DD HH:mm:ss');
};

export const extractVendorsFromTransaction = (transaction) => {
  const vendors = new Set();
  // Traverse through session_projections to find all vendors
  transaction.session_projections?.forEach(projection => {
    if (projection.output?.meta?.vendor) {
      vendors.add(projection.output.meta.vendor);
    }
  });
  return Array.from(vendors);
};

export const extractVendorVersionsFromTransaction = (transaction) => {
  const vendors = new Map();
  transaction.session_projections?.forEach(projection => {
    const vendorCode = projection.output?.meta?.vendor || projection.vendor;
    if (!vendorCode) return;

    const livenessVersion = vendorCode === "vg" && projection.service_name === "verilive"
      ? projection.liveness_version || null
      : null;
    const key = JSON.stringify([vendorCode, livenessVersion]);
    vendors.set(key, { vendorCode, livenessVersion });
  });
  return Array.from(vendors.values());
};

export const calculateDurationInSeconds = (startDate, endDate) => {

    const startMoment = moment(startDate);
    const endMoment = moment(endDate);

    const durationInSeconds = endMoment.diff(startMoment, 'seconds');

    return durationInSeconds;

}
export function extractFlowFormIdentity(transaction) {
  const status = transaction?.service_statuses?.find(
    (s) =>
      s.service_name === "flow-form" &&
      s.session_result?.form_type === "identity-form" &&
      s.session_result?.identity_form?.iin
  );
  return status?.session_result?.identity_form ?? null;
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
export const serviceMap = new Map([
    ["egov-doc", "Document Recognition"],
    ["veridoc", "Document Recognition"],
    ["veriface", "Face Matching (1:1)"],
    ["verilive", "Liveness Detection"],
    ["aml-cft", "AML / CFT Check"],
    ["flow-form", "Flow Form"],
    ["consent", "Consent"],
    ["flow-end", "Flow End"],
    ["veriphone", "Phone Verification"],
    ["kyc-list", "Blacklist"],
    ["esign", "Esign"]
]);

export const buildServiceArtifactMap = (artifacts, download) => {
  const map = {};
  for (const { stateKey, label, service } of DOWNLOAD_ARTIFACT_CONFIG) {
    if (!service || !artifacts[stateKey]) continue;
    if (!map[service]) map[service] = [];
    map[service].push({ key: stateKey, label, onClick: download[stateKey] });
  }
  return map;
};

export const createDownloadHandlers = (flowId, artifacts) => {
  const download = {};
  const mediaButtons = [];

  for (const { stateKey, file, ext, label } of DOWNLOAD_ARTIFACT_CONFIG) {
    download[stateKey] = () => downloadFile(artifacts[stateKey], `${file}_${flowId}.${ext}`);
    if (label && artifacts[stateKey]) {
      mediaButtons.push({ stateKey, label });
    }
  }

  return { download, mediaButtons };
};

export const downloadFile = (url, filename) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export function getDefaultStateParams() {

    const queryParams = {
        defaultDateFrom: moment().subtract(24, 'hours'),
        defaultDateTo: moment(),
        defaultServiceName: "veridoc"
    };

    const paginationParams = {
        initialPageIndex: 0,
        defaultPageSize: 10
    };

    const fileDownloadParams = {
        defaultDownloadBatchSize: 100,
        initialDownloadCursorOffset: 0,
        defaultFileExtension: "xlsx",
        defaultMimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }

    const newQueryParams = {
        default_limit: 10,
        default_offset: '0',
        default_date_from: moment().subtract(24, 'hours'),
        default_date_to: moment(),
        default_sort: 'datetime:desc',
    };
    const filterOptions = [
      {
        label: "Country",
        value: "country_code",
        children: [
          {
            label: "Kazakhstan",
            value: "KAZ",
          },
          {
            label: "Thailand",
            value: "TH",
          },
          {
            label: "USA",
            value: "US",
          },
        ],
      },
      //TODO: currently doc_type filter is not working, uncomment when fixed on backend
      //   {
      //     label: "Document Type",
      //     value: "doc_type",
      //     children: [
      //       {
      //         label: "Passport",
      //         value: "passport",
      //       },
      //       {
      //         label: "ID Card",
      //         value: "id_card",
      //       },
      //     ],
      //   },
      {
        label: "Status",
        value: "frontend_session_status",
        children: [
          {
            label: "Approved",
            value: "approved",
          },
          {
            label: "Denied",
            value: "denied",
          },
          {
            label: "Suspicious",
            value: "suspicious",
          },
          {
            label: "Expired",
            value: "expired",
          },
          {
            label: "Expected",
            value: "expected",
          },
          {
            label: "Failed",
            value: "failure",
          },
          {
            label: "Active",
            value: "active",
          },
        ],
      },
    ];
    const createTransactionMap = (transactions) => {
        const transactionMap = {};

        if (typeof transactions !== 'object') return transactionMap;

        transactions.forEach((transaction) => {
            const { flow_id } = transaction;
            transactionMap[flow_id] = transaction;
        });

        return transactionMap;
    }

    const convertToCountryName = (code) => {
        return countries.getName(code, "en");
    }
    const defaultDocData = {
        "First Name": "-",
        "Last Name": "-",
        Gender: "-",
        "Date of birth": "-",
        "Country of Document": "-",
        "Document type": "-",
        "Document number": "-",
        "Issued by": "-",
        "Issue date": "-",
        "Expiration date": "-",
    };

    const serviceStatuses = {
        "Document Recognition": {
            status: "-",
            color: "gray",
            counter: "-",
            result: "-",
        },
        "Liveness Detection": {
            status: "-",
            color: "gray",
            counter: "-",
            result: "-",
        },
        "Face Matching (1:1)": {
            status: "-",
            color: "gray",
            counter: "-",
            result: "-",
        },
        "Face Matching (1:N)": {
            status: "-",
            color: "gray",
            counter: "-",
            result: "-",
        },
        "AML / CFT Check": {
            status: "-",
            color: "gray",
            result: "-",
            counter: "-",
        },
        "Phone Verification": {
            status: "-",
            color: "gray",
            result: "-",
            counter: "-",
        },
        "Blacklist":{
            status: "-",
            color: "gray",
            result: "-",
            counter: "-",
        },
        "ERD (Register of Debtors)":{
            status: "-",
            color: "gray",
            result: "-",
            counter: "-",
        }
    };

    const statusOptions = [
        {
            label: "Approved",
            value: "approved",
        },
        {
            label: "Denied",
            value: "denied",
        },
    ];

    return { statusOptions, defaultDocData, serviceStatuses, queryParams, paginationParams, fileDownloadParams, newQueryParams, filterOptions, createTransactionMap, convertToCountryName, getFlagEmoji, extractVendorsFromTransaction, convertDateFormat, calculateDurationInSeconds, capitalizeFirstLetter, serviceMap, getTransactionStatusType, getTransactionStatus, getTransactionErrorDescription, getTransactionTimeAtUTC, getVendorDisplay };
}

